import type {
  CampaignDetailsResponse,
  CampaignDetails,
} from './tripsApi.model';

export function mapResponseToCampaignDetails(
  response: CampaignDetailsResponse
): CampaignDetails {
  return {
    headline: response.headline,
    salesPitch: response.salesPitch,
    description: {
      html: response.description.html,
      portableText: response.description.portableText,
    },
  };
}
